import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/table-head.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moJob from './store';
import moIndex from '../store/index';

interface IProps {}
interface IState {}

const TableHead = (props: IProps, state: IState) => {
  const navi = useNavigate();

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="table-head-1616">
      <strong className="strong-01">行业</strong>
      <strong className="strong-02">职能</strong>
      <strong className="strong-03">市场职位</strong>
      <p className="title-1616">
        <b>年固定薪酬</b>
        <span>
          <i className="i-01">10分位</i>
          <i className="i-02">50分位</i>
          <i className="i-03">90分位</i>
        </span>
      </p>
      <p className="title-1616">
        <b>年总现金收入</b>
        <span>
          <i className="i-01">10分位</i>
          <i className="i-02">50分位</i>
          <i className="i-03">90分位</i>
        </span>
      </p>
    </section>
  );
};

export default observer(TableHead);
